import _regeneratorRuntime from "D:/nodeApp/hj-aadmin-vue-new/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/nodeApp/hj-aadmin-vue-new/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/nodeApp/hj-aadmin-vue-new/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import LangSelect from '@/components/LangSelect';
import { resetRouter } from '@/router';
export default {
  components: {
    Breadcrumb: Breadcrumb,
    Hamburger: Hamburger,
    LangSelect: LangSelect
  },
  computed: _objectSpread({}, mapGetters(['sidebar', 'device', 'userInfo'])),
  mounted: function mounted() {
    var _this = this;
    window.addEventListener('beforeunload', function (e) {
      return _this.beforeunloadHandler(e);
    });
    window.addEventListener('unload', function (e) {
      return _this.unloadHandler(e);
    });
  },
  destroyed: function destroyed() {
    var _this2 = this;
    window.removeEventListener('beforeunload', function (e) {
      return _this2.beforeunloadHandler(e);
    });
    window.removeEventListener('unload', function (e) {
      return _this2.unloadHandler(e);
    });
  },
  methods: {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    logout: function logout() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              resetRouter();
              _context.next = 3;
              return _this3.$store.dispatch('user/resetToken');
            case 3:
              _context.next = 5;
              return _this3.$store.dispatch('permission/resetPermissions');
            case 5:
              _context.next = 7;
              return _this3.$store.dispatch('tagsView/delAllViews');
            case 7:
              _this3.$router.push("/admin/login?redirect=".concat(_this3.$route.fullPath));
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    beforeunloadHandler: function beforeunloadHandler() {
      this._beforeUnload_time = new Date().getTime();
    },
    unloadHandler: function unloadHandler(e) {
      this._gap_time = new Date().getTime() - this._beforeUnload_time;
      // 判断是窗口关闭还是刷新
      if (this._gap_time <= 5) {
        // 如果是登录状态，关闭窗口前，移除用户
        if (!this.showLoginButton) {
          this.logout();
        }
      }
    }
  }
};